import { Result, Row } from 'antd'
import KCol from 'app/components/UI-Elements/Layout/KCol'
import useTranslation from 'app/lib/hooks/useTranslation'
import * as React from 'react'

type Props = {
  subTitle?: string
}

const NotAuthorized: React.FC<Props> = ({ subTitle }) => {
  const { t } = useTranslation()
  return (
    <Row justify="center">
      <KCol card span={24}>
        <Result
          status="403"
          title="403"
          subTitle={subTitle ?? t({ id: 'component.feedback.result.not_authorized.sub_title' })}
        />
      </KCol>
    </Row>
  )
}

export default NotAuthorized
